import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { queryClient } from '@hooks/queryClient';
import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batchId: string;
  setRequestedBy?: boolean;
}

export const useGenerateBatchReport = () => {
  return useMutation({
    mutationFn: async ({ batchId, setRequestedBy }: HookProps) => {
      await request(
        {
          path: `batches/batch-report`,
          method: 'POST',
          authenticate: true,
          fileDownload: true,
          dataObject: { batchId, setRequestedBy },
        },
        true,
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getUserReports'] });
      toast.success('The report is being generated.');
    },
    onError: (error) => {
      showErrorToast(error, 'Error generating the report!');
    },
  });
};
